const SVG_MARKUP_RE = /<svg\b[^>]*(?:\/>|>[\s\S]*<\/svg>)/i;

export function extractSvgMarkup(raw) {
    if (!raw || typeof raw !== 'string') return '';
    const match = raw
        .replace(/^\uFEFF/, '')
        .trim()
        .match(SVG_MARKUP_RE);
    if (!match) return '';

    return match[0]
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/<foreignObject[\s\S]*?<\/foreignObject>/gi, '')
        .replace(/\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
        .replace(/javascript\s*:/gi, '');
}

export const DEFAULT_ICON_SVG = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M12 2l2.4 7.2H22l-6 4.8 2.3 7.2L12 16.8 5.7 21.2 8 14 2 9.2h7.6L12 2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
</svg>`;
